import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { useStyleStore } from "@vcl";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Color of the icon prefix on the Feed's filter toolbar. Own key so it stays
// scoped to the toolbar and doesn't bleed into other Feed icon-color options.
export default class FilterToolbarIconColor extends BaseOption {
  static userInterfaceComponent = {
    label: "Filter Icon Color",
    component: inspectorTools.COLOR_PICKER,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      width: "fill",
      colorContext: "Icons",
    },
  };

  static defaultValue = {
    value: "standard",
    source: "theme.icon",
  };

  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit") {
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];

    if (typeof themeMode === "object") {
      themeMode = "inherit";
    }

    if (configValue.source && configValue.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(configValue, styleStore.themes[themeId], palette, themeId, themeMode);
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue?.value;
  }
}
